import React from "react";

const Footer = () => {
  return (
    <>
      <div className="section footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="flex">
                <div className="social-media">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 44 44"
                    >
                      <g id="Layer_2" data-name="Layer 2" opacity="0.8">
                        <g
                          id="Layer_1"
                          data-name="Layer 1"
                          transform="translate(0 0)"
                        >
                          <path
                            id="Path_7"
                            data-name="Path 7"
                            d="M23.381,44.05H20.626c-.138-.026-.276-.057-.416-.078-.918-.134-1.851-.21-2.755-.407A21.522,21.522,0,0,1,4.461,35.287,21.4,21.4,0,0,1,.215,19.073a21.317,21.317,0,0,1,6.1-12.412A21.514,21.514,0,0,1,18.217.388c.8-.141,1.607-.229,2.411-.338h2.755c.736.1,1.475.164,2.205.289A21.6,21.6,0,0,1,36.61,5.624a21.657,21.657,0,0,1,7.057,12.638c.142.8.23,1.61.338,2.416v2.75a2.582,2.582,0,0,0-.071.331,21.018,21.018,0,0,1-3,9.476A21.752,21.752,0,0,1,25.793,43.719C25,43.863,24.186,43.935,23.381,44.05Zm4.471-33.97c-1.567,0-3.087-.08-4.592.018A4.589,4.589,0,0,0,18.7,14.352a32.208,32.208,0,0,0-.107,3.43v.548H16.1v4.5h2.494v12.72H23.9V22.807h3.575c.155-1.508.305-2.98.459-4.514H23.9c0-.959-.018-1.861.007-2.762a1.044,1.044,0,0,1,1.168-1.092c.774-.014,1.546,0,2.32,0,.149,0,.3-.016.459-.024Z"
                            transform="translate(-0.005 -0.05)"
                            // fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span
                    onClick={() => {
                      window.open("https://twitter.com/fidus_india", "_blank");
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 44 44"
                    >
                      <g id="Layer_2" data-name="Layer 2" opacity="0.8">
                        <g
                          id="Layer_1"
                          data-name="Layer 1"
                          transform="translate(0)"
                        >
                          <path
                            id="Path_12"
                            data-name="Path 12"
                            d="M20.282,0H23.72c.044.105.14.078.219.085a21.047,21.047,0,0,1,9.3,3.013A21.762,21.762,0,0,1,43.759,18.737,8.1,8.1,0,0,0,44,20.277v3.438c-.1.047-.078.142-.086.222a21.546,21.546,0,0,1-5.328,12.492,21.674,21.674,0,0,1-13.366,7.335A9.159,9.159,0,0,0,23.633,44H20.2c-.068-.136-.2-.081-.3-.093a23.707,23.707,0,0,1-3.5-.628A22.006,22.006,0,0,1,18.741.24,7.453,7.453,0,0,0,20.282,0ZM16.747,27.207a4.71,4.71,0,0,1-1.189.7,8.944,8.944,0,0,1-3.921.791c-.241,0-.521-.048-.611.26-.1.338.2.431.41.565.024.015.049.028.075.04a12.789,12.789,0,0,0,12.058.246c4.6-2.286,6.857-6.223,7.191-11.292a1.719,1.719,0,0,1,.647-1.4,7.038,7.038,0,0,0,1.429-1.593c.093-.135.248-.268.1-.458s-.314-.061-.467,0a3.131,3.131,0,0,1-1.193.32,5.009,5.009,0,0,0,1.045-1.667c.055-.156.171-.324-.016-.469-.158-.123-.3-.014-.433.062a10.973,10.973,0,0,1-1.778.764,1.142,1.142,0,0,1-1.182-.211,4.583,4.583,0,0,0-5.09-.473,4.445,4.445,0,0,0-2.534,4.338c0,.634,0,.646-.641.554a12.436,12.436,0,0,1-7.915-4.321c-.354-.413-.475-.4-.713.108a4.669,4.669,0,0,0,.49,5.017c.093.128.2.251.294.376a2.15,2.15,0,0,1-.72-.2c-.52-.229-.633-.16-.593.421a4.7,4.7,0,0,0,2.226,3.766c.115.074.265.1.327.262-.126,0-.24.009-.353,0-.709-.063-.768.015-.479.673A4.823,4.823,0,0,0,16.747,27.207Z"
                            transform="translate(-0.002)"
                            // fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span
                    onClick={() => {
                      window.open(
                        "https://in.linkedin.com/in/fidus-india-a5a030242?trk=public_post_follow-view-profile",
                        "_blank"
                      );
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 44 44"
                    >
                      <g id="Layer_2" data-name="Layer 2" opacity="0.8">
                        <g id="Layer_1" data-name="Layer 1">
                          <path
                            id="Path_18"
                            data-name="Path 18"
                            d="M20.711,0h2.664a2.364,2.364,0,0,0,.331.07,20.987,20.987,0,0,1,9.258,2.865,21.72,21.72,0,0,1,10.7,15.273c.15.8.229,1.611.337,2.417v2.664c-.024.138-.054.275-.073.414-.115.863-.195,1.735-.36,2.59A21.977,21.977,0,0,1,25.788,43.663c-.8.135-1.6.229-2.413.337h-2.75a1.69,1.69,0,0,0-.284-.071A19.577,19.577,0,0,1,14.9,42.8Q2.913,38.367.344,25.832C.182,25.023.115,24.195,0,23.376v-2.75c.115-.8.2-1.613.337-2.414A21.968,21.968,0,0,1,17.7.433C18.7.242,19.708.142,20.711,0ZM33.561,33.566c.009-.154.024-.28.024-.4,0-2.707.032-5.414-.015-8.12a19.492,19.492,0,0,0-.336-3.365,4.33,4.33,0,0,0-3.214-3.654,8.34,8.34,0,0,0-2.074-.284,5.034,5.034,0,0,0-4.59,2.354c-.018.028-.062.038-.154.089V18.149h-4.56v15.4h4.744v-.545c0-2.391-.007-4.783,0-7.174a5.462,5.462,0,0,1,.48-2.55A2.628,2.628,0,0,1,26.8,22a2.088,2.088,0,0,1,1.8,1.865,9.723,9.723,0,0,1,.17,1.749c.018,2.491.009,4.983.01,7.474v.479ZM15.583,18.157H10.84v15.4h4.744ZM13.161,16A2.792,2.792,0,1,0,10.4,13.2,2.792,2.792,0,0,0,13.161,16Z"
                            // fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span
                    onClick={() => {
                      window.open(
                        "https://www.instagram.com/fidus_india?igsh=ZW1lYmxkeHI0YXpi",
                        "_blank"
                      );
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 44 44"
                    >
                      <g
                        id="Layer_2"
                        data-name="Layer 2"
                        transform="translate(0 0.001)"
                        opacity="0.8"
                      >
                        <g
                          id="Layer_1"
                          data-name="Layer 1"
                          transform="translate(0 -0.001)"
                        >
                          <path
                            id="Path_14"
                            data-name="Path 14"
                            d="M21.986,44A22,22,0,1,1,44,22,22.012,22.012,0,0,1,21.986,44ZM34.222,22.025v-4.5a7.546,7.546,0,0,0-7.756-7.747H17.422A7.547,7.547,0,0,0,9.785,17.4q-.016,4.6,0,9.191a7.546,7.546,0,0,0,7.635,7.623q4.595.012,9.19,0a7.543,7.543,0,0,0,7.611-7.6C34.227,25.093,34.222,23.561,34.222,22.025Z"
                            transform="translate(0 0.001)"
                            // fill="#fff"
                          />
                          <path
                            id="Path_15"
                            data-name="Path 15"
                            d="M115.262,105.617v4.522a4.881,4.881,0,0,1-5.091,5.1q-4.571.012-9.143,0a4.873,4.873,0,0,1-5.063-5.074q-.011-4.571,0-9.143a4.883,4.883,0,0,1,5.064-5.079q4.6-.017,9.192,0A4.881,4.881,0,0,1,115.257,101C115.269,102.541,115.262,104.082,115.262,105.617Zm-3.3-.042a6.376,6.376,0,1,0,0,.005Zm.31-5.647a1.063,1.063,0,1,0,0,.005Z"
                            transform="translate(-83.609 -83.591)"
                            // fill="#fff"
                          />
                          <path
                            id="Path_16"
                            data-name="Path 16"
                            d="M147.383,143.512a3.861,3.861,0,1,1-3.871-3.852A3.861,3.861,0,0,1,147.383,143.512Z"
                            transform="translate(-121.518 -121.522)"
                            // fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                </div>
                <div className="copyright">
                  <span>© 2024 Fidus, All Rights Reserved</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
